"use strict";
function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/rxjs/util/isFunction.js
 ** module id = 303
 ** module chunks = 0
 **/